var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkon02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63 60",
    style: {
      enableBackground: "new 0 0 63 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#263D50;stroke-width:2;stroke-linecap:square;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_16618-4",
    transform: "translate(1439.941 494.343) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_744-9",
    className: "st0",
    x1: -1325,
    y1: 709.2,
    x2: -1325,
    y2: 668.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_745-9",
    className: "st0",
    x1: -1325,
    y1: 668.1,
    x2: -1366.2,
    y2: 668.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16618-4_1_",
    transform: "translate(1439.941 494.343) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_744-9_1_",
    className: "st0",
    x1: -1302.9,
    y1: 687.6,
    x2: -1302.9,
    y2: 646.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_745-9_1_",
    className: "st0",
    x1: -1302.9,
    y1: 646.5,
    x2: -1344.1,
    y2: 646.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkon02);
export default __webpack_public_path__ + "static/media/ikon_02.ac1cefafe52c0d4bf7b4d164df1a9fb3.svg";
export { ForwardRef as ReactComponent };